import { useMemo } from 'react';

import { TYPE_A, TYPE_B, TYPE_C, TYPE_K, TYPE_L } from '../../common/constants/img';
import {
  DESIGN_INLINE_VERTICAL,
  DESIGN_STANDARD,
  DESIGN_VERTICAL,
  DESKTOP_TYPE_PADDING_DIVIDER,
  MOBILE_TYPE_PADDING_DIVIDER,
  SIZE_LARGE,
} from '../constants/carousels';
import breakpoints from '@/mui/constants/breakpoints';

import { DesignEnum, SizeEnum } from '@/modules/ChannelList/types/carousels';

import { useBreakpointRange, useSmallScreen } from '@/modules/common/helpers/customHooks';

export const useSlideDimensions = (design: DesignEnum, size: SizeEnum) => {
  const decreaseStandardType = useBreakpointRange(breakpoints.values.xs, breakpoints.values.md);
  const isSmallScreen = useSmallScreen();

  return useMemo(() => {
    let dimensions = isSmallScreen ? TYPE_C : TYPE_B;

    if ([DESIGN_VERTICAL, DESIGN_INLINE_VERTICAL].includes(design)) {
      dimensions = isSmallScreen ? TYPE_L : TYPE_K;
    } else if (design === DESIGN_STANDARD && size === SIZE_LARGE) {
      dimensions = decreaseStandardType ? TYPE_B : TYPE_A;
    }

    return {
      ...dimensions,
      padding: isSmallScreen ? MOBILE_TYPE_PADDING_DIVIDER : DESKTOP_TYPE_PADDING_DIVIDER,
    };
  }, [decreaseStandardType, isSmallScreen]);
};
